<template>
  <NotFoundView v-if="appLoadFailed" />
  <MobileView v-else-if="isMobile" />
  <VisualisationView v-else />
</template>

<script lang="ts">
import Component from 'vue-class-component'

import { useFeedbackStore } from '@/store/public/feedback'
import PublicViewMetaInfo from '@/views/public/PublicViewMetaInfo'
import NotFoundView from '@/views/public/NotFoundView.vue'
import MobileView from '@/views/public/MobileView.vue'
import VisualisationView from '@/views/public/VisualisationView.vue'

const components = {
  NotFoundView,
  MobileView,
  VisualisationView,
}

// eslint-disable-next-line no-use-before-define
@Component<PublicView>({
  components,
  watch: {
    secondaryAppId: {
      handler() {
        this.initialiseSecondaryApp()
        this.$typedStore.public.size.recalculate()
      },
      immediate: true,
    },
  },
})
export default class PublicView extends PublicViewMetaInfo {
  get appLoaded() {
    return this.$typedStore.primary.app.appLoaded
  }

  get mainpanel() {
    return this.$typedStore.currentRoute.params.mainpanel
  }

  get isMobile() {
    return this.$typedStore.public.display.isMobile
  }

  get appLoadFailed() {
    return this.$typedStore.primary.app.appLoadFailed
  }

  get showSetupWizard() {
    return this.$typedStore.currentRoute.query.showSetupWizard === 'true'
  }

  get secondaryAppId() {
    return this.$typedStore.public.display.activeTab?.secondaryAppId
  }

  async mounted() {
    useFeedbackStore().determineIsKiosk()
    await this.initialiseApps()
    this.setInitialVisualisationType()
    this.$typedStore.public.size.recalculate()
    if (this.showSetupWizard) {
      this.$bvModal.show('builder-wizard-modal')
    }
  }

  async initialiseApps() {
    await this.$typedStore.primary.app.initialise()
    await this.initialiseSecondaryApp()
  }

  async initialiseSecondaryApp() {
    if (this.$typedStore.activeVisualisation.isSecondaryApp) {
      await this.$typedStore.secondary.app.initialise()
    }
  }

  setInitialVisualisationType() {
    const { initialVisualisationType } = this.$typedStore.public.display
    if (initialVisualisationType) {
      this.$typedStore.activeVisualisation.setActiveVisualisationType({
        appId: this.$typedStore.activeVisualisation.appId,
        visualisationType: initialVisualisationType,
      })
    }
  }
}
</script>
